/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IWebgroupFiltersExtendedProps } from './webgroup-filters';
import Msdyn365 from '@msdyn365-commerce/core';

export default (props: IWebgroupFiltersExtendedProps) => {
    const [clearFilters, setClearFilters] = React.useState(false);
    if (Msdyn365.isBrowser) {
        document.addEventListener('FILTERS_UPDATED', (data: any) => {
            data.detail.length ? setClearFilters(true) : setClearFilters(false);
        });
    }

    return (
        <>
            <h4 className='webgroup-title'>
                Filters
                {clearFilters && (
                    <span className='clear-filters' onClick={() => props.clearFilters()}>
                        Clear
                    </span>
                )}
            </h4>
            <div className='webgroup-filters'>{props.accordions}</div>
        </>
    );
};
